const Home = () => {
  return (
    <div>Welcome Home.</div>
  )
}

export default Home;